"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
//测试流通股
var TEST_FINANCE_7 = {

	"data": [{
		"Value": 900000000,
		"Date": 19000101
	}, {
		"Value": 900000000,
		"Date": 20050826
	}, {
		"Value": 1170000000,
		"Date": 20060509
	}, {
		"Value": 1170000000,
		"Date": 20060812
	}, {
		"Value": 1332263340,
		"Date": 20061129
	}, {
		"Value": 3260608265.0000005,
		"Date": 20070509
	}, {
		"Value": 3538227622,
		"Date": 20071124
	}, {
		"Value": 4599695909,
		"Date": 20080418
	}, {
		"Value": 5012174267,
		"Date": 20080507
	}, {
		"Value": 5661347506,
		"Date": 20090506
	}, {
		"Value": 7925886507.999999,
		"Date": 20090603
	}, {
		"Value": 7925886507.999999,
		"Date": 20090930
	}, {
		"Value": 7925886507.999999,
		"Date": 20100407
	}, {
		"Value": 10303652460,
		"Date": 20100604
	}, {
		"Value": 11479059332,
		"Date": 20100921
	}, {
		"Value": 11479059332,
		"Date": 20101016
	}, {
		"Value": 14922777132.000002,
		"Date": 20110530
	}, {
		"Value": 14922777132.000002,
		"Date": 20141210
	}, {
		"Value": 14922777132.000002,
		"Date": 20150323
	}, {
		"Value": 18653471415,
		"Date": 20151010
	}, {
		"Value": 18653471415,
		"Date": 20160322
	}, {
		"Value": 20518818557,
		"Date": 20160616
	}, {
		"Value": 20518818557,
		"Date": 20160811
	}, {
		"Value": 21618279922.000004,
		"Date": 20170314
	}, {
		"Value": 28103763899,
		"Date": 20170519
	}, {
		"Value": 28103763899,
		"Date": 20170906
	}, {
		"Value": 28103415399.000004,
		"Date": 20180713
	}, {
		"Value": 28103763899,
		"Date": 20190326
	}, {
		"Value": 28103794811.999996,
		"Date": 20200703
	}, {
		"Value": 28103805551,
		"Date": 20200716
	}, {
		"Value": 28103815214,
		"Date": 20200901
	}, {
		"Value": 29352131712.000004,
		"Date": 20200901
	}, {
		"Value": 29352134127.000004,
		"Date": 20201012
	}, {
		"Value": 29352140893,
		"Date": 20210105
	}, {
		"Value": 29352144411.999996,
		"Date": 20210402
	}, {
		"Value": 29352156163,
		"Date": 20210703
	}, {
		"Value": 29352160584,
		"Date": 20210713
	}, {
		"Value": 29352165582,
		"Date": 20211009
	}, {
		"Value": 29352168006.000004,
		"Date": 20220106
	}, {
		"Value": 29352171861,
		"Date": 20220402
	}, {
		"Value": 29352172360,
		"Date": 20220702
	}, {
		"Value": 29352173289,
		"Date": 20220713
	}, {
		"Value": 29352173656,
		"Date": 20221011
	}, {
		"Value": 29352174170,
		"Date": 20230105
	}, {
		"Value": 29352174759,
		"Date": 20230404
	}, {
		"Value": 29352175421.000004,
		"Date": 20230704
	}, {
		"Value": 29352175642,
		"Date": 20230713
	}, {
		"Value": 29352176396,
		"Date": 20231009
	}, {
		"Value": 29352176396,
		"Date": 20231009
	}, {
		"Value": 29352176396,
		"Date": 20231009
	}, {
		"Value": 29352176848,
		"Date": 20240104
	}, {
		"Value": 29352177224,
		"Date": 20240403
	}, {
		"Value": 29352177375,
		"Date": 20240702
	}] /*暴露外部用的方法*/
};exports.TEST_FINANCE_7 = TEST_FINANCE_7;


//////////////////
// WEBPACK FOOTER
// ./~/hqchart/src/jscommon/umychart.vue.testdataV2/60000.sh.finance_7.js
// module id = 308
// module chunks = 0